import { render } from "./SendForApprovalModal.vue?vue&type=template&id=6b0b997a&scoped=true"
import script from "./SendForApprovalModal.vue?vue&type=script&lang=js"
export * from "./SendForApprovalModal.vue?vue&type=script&lang=js"

import "./SendForApprovalModal.vue?vue&type=style&index=0&id=6b0b997a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0b997a"]])

export default __exports__